const VI_CUSTOM = {

}

export default VI_CUSTOM;